import { render, staticRenderFns } from "./orderValueChartWidget.vue?vue&type=template&id=44072a22&"
import script from "./orderValueChartWidget.vue?vue&type=script&lang=js&"
export * from "./orderValueChartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports